
export default function FarmingtonNeighborhoods() {
  const neighborhoods = [
    {
      name: 'Station Park Area',
      description: 'Newer developments near Station Park shopping center with modern homes and businesses requiring specialized water damage restoration services.',
      icon: 'ri-shopping-bag-line'
    },
    {
      name: 'Historic Downtown Farmington',
      description: 'Charming historic homes along Main Street and surrounding areas, where we provide careful restoration preserving original character.',
      icon: 'ri-building-line'
    },
    {
      name: 'Lagoon Vicinity',
      description: 'Residential areas near Lagoon amusement park, including properties along Lagoon Drive requiring flood prevention and water damage services.',
      icon: 'ri-community-line'
    },
    {
      name: 'East Farmington',
      description: 'Hillside properties with stunning mountain views, where we address unique drainage and water damage challenges.',
      icon: 'ri-landscape-line'
    },
    {
      name: 'Farmington Creek Area',
      description: 'Properties near Farmington Creek requiring specialized flood protection and rapid emergency response services.',
      icon: 'ri-water-flash-line'
    },
    {
      name: 'West Farmington',
      description: 'Growing residential communities near I-15 corridor with modern homes and commercial properties we proudly serve.',
      icon: 'ri-home-4-line'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Farmington Neighborhoods We Serve
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            Fast water damage restoration response throughout all Farmington areas
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {neighborhoods.map((neighborhood, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 md:p-8 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <div className="w-11 h-11 md:w-14 md:h-14 bg-sky-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className={`${neighborhood.icon} text-xl md:text-2xl text-sky-600`}></i>
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{neighborhood.name}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{neighborhood.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
